import {useState} from "react";
import './AIGeneratedContent.scss';
import { MotifFormField } from "@ey-xd/motif-react";
import { MotifSelect } from "@ey-xd/motif-react";
import { MotifTextArea } from "@ey-xd/motif-react";
import { MotifInput } from "@ey-xd/motif-react";
import { MotifOption } from "@ey-xd/motif-react";
import { MAX_INPUT_LENGTH, MAX_TEXTAREA_LENGTH, isMaliciousInput, maliciousInputErrorMsg } from "components/Clients/constants";
import MotifErrorMessage from "@ey-xd/motif-react/components/forms/error-message";
import { MotifMessage } from "@ey-xd/motif-react";
import { avoidXSSattack } from "utils/security";
import { MotifAccordion, MotifAccordionTrigger, MotifAccordionContent, MotifAccordionGroup } from "@ey-xd/motif-react";



interface FormData {
  cvss_vector?: string;
  cvss_score?: string;
  cvss_severity?: string;
  likelihood?: string;
  recommendation?: string;
  priority?: string;
  complexity?: string;
  references?: string;
  cvssValidation?: boolean;
  llm_reason?: string;
  baseline_cvss_vector?: string;
  cvss_score_changed?: boolean;
}

interface FormProps {
  formData: FormData;
  handleFormChange: any;
  findingId?: number;

}

const AIGeneratedContent: React.FC<FormProps> = ({ formData, handleFormChange, findingId }) => {
  const[isOpenReason, setIsOpenReason] = useState(false);
  const options = ['High', 'Medium', 'Low','Info','Small', 'Medium', 'Large', 'Critical'];

  return (
    <div className="contentForm_container" onClick={(e: any) => e.stopPropagation()}>
      <div className="clientDetails__title">AI Generated Content</div>
      <div>This tool utilizes Generative AI technology to create reports. While we strive for accuracy, please review all  AI-generated content carefully before use, as it may contain errors or inaccuracies.</div>
      <div className='findingForm__form'>

        <span>AI Generated CVSS Vector</span>
        <MotifFormField className='clientDetails__formField'>
          <MotifInput
            value={formData?.cvss_vector || ''}
            onChange={(e: any) =>{ e=avoidXSSattack(e); handleFormChange(e, 'cvss_vector')}}
            style={formData?.cvssValidation? { borderColor: 'red' } : {}}
            maxLength={MAX_INPUT_LENGTH}
          />
                    {isMaliciousInput(formData?.cvss_vector || '') && <MotifErrorMessage role="alert">{maliciousInputErrorMsg}</MotifErrorMessage>}
          {formData?.cvss_score_changed && (
          <MotifMessage variant="warning" role="alert" style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
            {/* Inline SVG warning icon */}
            <svg width="16" height="16" fill="orange" style={{ marginRight: 6 }} viewBox="0 0 24 24">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
            </svg>
            There seems to be a mismatch in CVSS vector fields. Please choose the correct value.
          </MotifMessage>
          )}
        </MotifFormField>

        {/*  */}
          <>
            <span>Default CVSS Vector</span>
            <MotifFormField className='clientDetails__formField'>
              <MotifInput
                value={formData?.baseline_cvss_vector || ''}
                onChange={(e: any) => { e = avoidXSSattack(e); handleFormChange(e, 'baseline_cvss_vector') }}
                style={formData?.cvssValidation ? { borderColor: 'red' } : {}}
                maxLength={MAX_INPUT_LENGTH}
                disabled={true}
              />
              {isMaliciousInput(formData?.baseline_cvss_vector || '') && (
                <MotifErrorMessage role="alert">{maliciousInputErrorMsg}</MotifErrorMessage>
              )}
         
            </MotifFormField>
          </>
        {/*  */}
        <span>CVSS Score</span>
        <MotifFormField className='clientDetails__formField'>
          <MotifInput
            // value={formData?.cvss_score || "0.0"}
            value={Number(formData?.cvss_score) === 0 ? "0.0" : (formData?.cvss_score || "")}
            disabled={true}
          />
        </MotifFormField>
        <div className="clientDetails__formField">
        <MotifAccordionGroup>
          <MotifAccordion key={findingId} alignIconLeft useChevronIcon open={isOpenReason} onClose={()=>setIsOpenReason(!isOpenReason)}>
            <MotifAccordionTrigger>
              Reason
            </MotifAccordionTrigger>
            <MotifAccordionContent className="clientDetails__reasonContent">
                {formData?.llm_reason
                  ? (
                    (
                      formData.llm_reason.match(/\d+\./)
                        ? formData.llm_reason.split(/\.\s(?=\d)/)
                        : formData.llm_reason.split('.')
                    )
                      .filter(sentence => sentence.trim() !== '')
                      .map((sentence, idx, arr) => (
                        <span key={idx}>
                          {sentence.trim()}.
                          {idx < arr.length - 1}
                          <br />
                        </span>
                      ))
                  )
                  : 'N/A'}
            </MotifAccordionContent>
          </MotifAccordion>
        </MotifAccordionGroup>
        </div>
        <span>Severity</span>
        <MotifFormField className='clientDetails__formField'>
          <MotifSelect
            onChange={(e: any) => handleFormChange(e, 'cvss_severity')}
            value={formData?.cvss_severity}
            className={formData?.cvss_severity !== '' && 'value-selected'}
            disabled={true}
          >
            {options.map((ele: any, index: number) => (
              <MotifOption value={ele} key={index}>{ele}</MotifOption>
            ))}
          </MotifSelect>
        </MotifFormField>

        <span>Select Vulnerability Likelihood</span>
        <MotifFormField className='clientDetails__formField'>
          <MotifSelect
            onChange={(e: any) => handleFormChange(e, 'likelihood')}
            value={formData?.likelihood}
            className={formData?.likelihood !== '' && 'value-selected'}
          >
            {options.map((ele: any, index: number) => (
              <MotifOption value={ele} key={index}>{ele}</MotifOption>
            ))}
          </MotifSelect>
        </MotifFormField>

        <span>Recommendation</span>
        <MotifFormField className='clientDetails__formField'>
          <MotifTextArea
            value={formData?.recommendation || ''}
            onChange={(e: any) => handleFormChange(e, 'recommendation')}
            className={formData?.recommendation !== '' && 'value-available'}
            maxLength={MAX_TEXTAREA_LENGTH}
          />
           {isMaliciousInput(formData?.recommendation || '') && <MotifErrorMessage role="alert">{maliciousInputErrorMsg}</MotifErrorMessage>}
           <MotifMessage className='txtAlignRight'> {`${formData?.recommendation?.length}/${MAX_TEXTAREA_LENGTH} characters remaining`}</MotifMessage>
        </MotifFormField>

        <span>Priority</span>
        <MotifFormField className='clientDetails__formField'>
          <MotifSelect
            value={formData?.priority}
            onChange={(e: any) => handleFormChange(e, 'priority')}
            className={formData?.priority !== '' && 'value-selected'}
          >
            {options.map((ele: any, index: number) => (
              <MotifOption value={ele} key={index}>{ele}</MotifOption>
            ))}
          </MotifSelect>
        </MotifFormField>

        <span>Complexity</span>
        <MotifFormField className='clientDetails__formField'>
          <MotifSelect
            value={formData?.complexity}
            onChange={(e: any) => handleFormChange(e, 'complexity')}
            className={formData?.complexity !== '' && 'value-selected'}
          >
            {options.map((ele: any, index: number) => (
              <MotifOption value={ele} key={index}>{ele}</MotifOption>
            ))}
          </MotifSelect>
        </MotifFormField>

        <span>References - URLs</span>
        <MotifFormField className='clientDetails__formField'>
          <MotifTextArea
            value={formData?.references || ''}
            onChange={(e: any) => { e=avoidXSSattack(e); handleFormChange(e, 'references')}}
            className={formData?.references !== '' && 'value-available'}
            maxLength={MAX_TEXTAREA_LENGTH}
          />
          <MotifMessage className='txtAlignRight'> {`${formData?.references?.length}/${MAX_TEXTAREA_LENGTH} characters remaining`}</MotifMessage>
          {isMaliciousInput(formData?.references || '') && <MotifErrorMessage role="alert">{maliciousInputErrorMsg}</MotifErrorMessage>}
        </MotifFormField>
      </div>
    </div>
  );
};

export default AIGeneratedContent;
